module.exports = __webpack_public_path__ + "img/huohua-ppt@2x.e1a61897.png";